import MainImg from "../../assest/about/about0.jpg";
import leftImg from "../../assest/about/about1.jpg";
import rightImg from "../../assest/about/about2.jpg";
import leftSvg from "../../assest/about/ovals.svg";
import leftDot from "../../assest/about/dots1.svg";
import rightDot from "../../assest/about/dots2.svg";
import rightSvg from "../../assest/about/oval1.svg";
import { motion } from "framer-motion";

const About = () => {
  const headingTextVariants = {
    hidden: { opacity: 0, y: 30 }, // Text starts from below
    visible: { opacity: 1, y: 0, transition: { duration: 1.8 } }, // Text comes to its normal position
  };

  const leftImageVariants = {
    hidden: { opacity: 0, x: -100 }, // Initial position for the left-side div (hidden, moved to the left)
    visible: { opacity: 1, x: 0, transition: { duration: 2 } }, // Slower transition (duration: 2s)
  };

  const rightContentVariants = {
    hidden: { opacity: 0, x: 100 }, // Initial position for the right-side div (hidden, moved to the right)
    visible: { opacity: 1, x: 0, transition: { duration: 2 } }, // Slower transition (duration: 2s)
  };

  const mainImageVariant = {
    hidden: { opacity: 0 }, // Initial position for the right-side div (hidden, moved to the right)
    visible: { opacity: 1, transition: { duration: 2.2 } }, // Slower transition (duration: 2s)
  };

  const leftImgVariant = {
    hidden: { opacity: 0, x: -80 }, // Initial position for the right-side div (hidden, moved to the right)
    visible: { opacity: 1, x: 0, transition: { duration: 2.3 } }, // Slower transition (duration: 2s)
  };

  const rightImgVariant = {
    hidden: { opacity: 0, rotateY: 180 }, // Initial position for the right-side div (hidden, moved to the right)
    visible: { opacity: 1, rotateY: 0, transition: { duration: 2.4 } }, // Slower transition (duration: 2s)
  };

  const leftSvgVariant = {
    hidden: { opacity: 0, z: 20 }, // Initial position for the right-side div (hidden, moved to the right)
    visible: { opacity: 1, z: 0, transition: { duration: 2.5 } }, // Slower transition (duration: 2s)
  };

  const leftDotVariant = {
    hidden: { opacity: 0, z: 20 }, // Initial position for the right-side div (hidden, moved to the right)
    visible: { opacity: 1, z: 0, transition: { duration: 2.6 } }, // Slower transition (duration: 2s)
  };

  const rightSvgVariant = {
    hidden: { opacity: 0 }, // Initial position for the right-side div (hidden, moved to the right)
    visible: { opacity: 1, transition: { duration: 2.7 } }, // Slower transition (duration: 2s)
  };

  const subHeadInfo = {
    hidden: { opacity: 0, x: 30 }, // Text starts from below
    visible: { opacity: 1, x: 0, transition: { duration: 2.8 } }, // Text comes to its normal position
  };

  const firstParaVariant = {
    hidden: { opacity: 0, y: 30 }, // Text starts from below
    visible: { opacity: 1, y: 0, delay: 0.5, transition: { duration: 2.9 } }, // Text comes to its normal position
  };

  const rightDotVariant = {
    hidden: { opacity: 0, rotate: 30 }, // Text starts from below
    visible: { opacity: 1, rotate: 0, transition: { duration: 3.1 } }, // Text comes to its normal position
  };

  return (
    <div className="about">
      <motion.h2
        variants={headingTextVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="sectionHeading"
      >
        ABOUT AAYOJAN
      </motion.h2>
      <div>
        <motion.div
          variants={leftImageVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="aboutGraphic"
        >
          <motion.img
            variants={mainImageVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            src={MainImg}
            alt="graphic"
            className="Img0"
          />
          <motion.img
            variants={leftImgVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            src={leftImg}
            alt="graphic"
            className="Img1"
          />
          <motion.img
            variants={rightImgVariant}
            src={rightImg}
            alt="graphic"
            className="Img2"
          />
          <motion.img
            variants={leftSvgVariant}
            initial="hidden"
            src={leftSvg}
            alt="graphic"
            className="Img3"
          />
          <motion.img
            variants={leftDotVariant}
            initial="hidden"
            whileInView="visible"
            src={leftDot}
            alt="graphic"
            className="Img4"
          />
          <motion.img
            variants={rightSvgVariant}
            initial="hidden"
            viewport={{ once: true }}
            src={rightSvg}
            alt="graphic"
            className="Img5"
          />
        </motion.div>
        <motion.div
          variants={rightContentVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="aboutText"
        >
          <motion.h3
            variants={subHeadInfo}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            A Comprehensive All-in-One solution <br />
            for Organizing, Registering and
            <br />
            Networking at all types of events
          </motion.h3>
          <motion.p
            variants={firstParaVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            Aayojan is an event management app simplifies the process of
            organizing and managing events. Users can create events, add
            participants, and efficiently manage all aspects through a
            user-friendly dashboard.
            <br />
            <br />
            With robust data analytics, secure payment options, and extensive
            administrative tools, our app ensures a seamless and secure event
            management experience.
          </motion.p>
        </motion.div>
        <motion.img
          variants={rightDotVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          src={rightDot}
          alt="img"
          className="Img6"
        />
      </div>
    </div>
  );
};

export default About;
